import React from 'react';
import MapButton from './MapButton';
import ZoomPlusSvg from 'assets/plus.svg?react';
import ZoomMinusSvg from 'assets/minus.svg?react';
import { useTranslation } from 'react-i18next';

export interface ZoomControlProps {
  zoomInCallback: (e: React.MouseEvent<HTMLButtonElement>) => void;
  zoomOutCallback: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const ZoomControl: React.FC<ZoomControlProps> = ({ zoomInCallback, zoomOutCallback }) => {
  const { t } = useTranslation();
  return (
    <div className="rounded-4 bg-white w-40px mt-8 mb-24 flex flex-col items-center">
      <MapButton
        id="zoomIn"
        className="w-100% h-40px flex items-center justify-center"
        callback={zoomInCallback}
        tooltipText={t('yield-analysis.map.zoom_in')}
      >
        <ZoomPlusSvg />
      </MapButton>
      <div className="bg-neutral-20 h-1px w-24px" />
      <MapButton
        id="zoomOut"
        className="w-100% h-40px flex items-center justify-center"
        callback={zoomOutCallback}
        tooltipText={t('yield-analysis.map.zoom_out')}
      >
        <ZoomMinusSvg />
      </MapButton>
    </div>
  );
};

export default ZoomControl;
